import React, { useCallback } from "react";
import { generateRandomId } from "Utils";
import {
  LTI_SERVICE_DETAILS,
  getLTIName,
} from "AppComponents/LTIComponent/modules/Utils";
import LTIComponent from "AppComponents/LTIComponent";
import { useI18n } from "Hooks";
import _ from "lodash";
import { createAssessmentTool } from "AssessmentToolSetup/modules/AssessmentToolSetupModule";
import { connect } from "react-redux";

const LTIClassroomWrapper = props => {
  const {
    onLinkAdd,
    toggleLTIComponent,
    createLTIScoreTool,
    createAssessmentTool,
    assessmentId,
    courseId,
    parentType,
    portalType,
  } = props;
  const { t } = useI18n();

  const onLTIModalSave = useCallback(
    props => {
      const { serviceName, attachmentContextId, initialLaunchUrl } = props;
      const serviceDetails = LTI_SERVICE_DETAILS?.[serviceName] || {};
      const {
        allowStudentReportView = false,
        disableTeacherReportView = false,
        useInAppBrowser = false,
        thumbUrl = "",
      } = serviceDetails;

      const attachments = [
        {
          metadata: {
            type: "LTI_TOOL",
            service: serviceName,
            allowStudentReportView,
            attachmentContextId,
            disableTeacherReportView,
            useInAppBrowser,
          },
          mimeType: null,
          name: t("classRoom:tool_resource_with_label", {
            label: getLTIName(serviceName) || serviceName,
          }),
          type: "LINK",
          url: initialLaunchUrl,
          thumbUrl,
        },
      ];

      onLinkAdd({
        attachments,
        id: generateRandomId(),
      });
      if (createLTIScoreTool) {
        createAssessmentTool({
          type: "SCORE",
          parentId: assessmentId,
          parentType,
          portalType,
          assessmentId,
        });
      }

      toggleLTIComponent();
    },
    [
      t,
      onLinkAdd,
      createLTIScoreTool,
      toggleLTIComponent,
      createAssessmentTool,
      assessmentId,
      parentType,
      portalType,
      courseId,
    ]
  );

  const onContentItemSelection = useCallback(
    props => {
      const {
        content_items,
        resourceLinkId,
        serviceName,
        version = "1.1",
      } = props;
      let attachmentDetails, thumbUrl, attachmentContextId;

      if (version === "1.3") {
        const { contentItems } = props;
        attachmentDetails = _.first(contentItems);
      } else {
        const contentItems = JSON.parse(content_items);
        attachmentDetails = _.first(_.get(contentItems, "@graph", null));
      }

      const serviceDetails = LTI_SERVICE_DETAILS?.[serviceName] || {};

      const {
        allowStudentReportView = false,
        disableTeacherReportView = false,
        useInAppBrowser = false,
      } = serviceDetails;

      if (_.get(attachmentDetails, "thumbUrl", null)) {
        thumbUrl = attachmentDetails?.thumbUrl;
      } else if (_.get(attachmentDetails?.thumbnail, "@id", null)) {
        thumbUrl = attachmentDetails?.thumbnail["@id"];
      } else {
        thumbUrl = LTI_SERVICE_DETAILS[serviceName]?.thumbUrl || "";
      }

      const name = _.get(
        attachmentDetails,
        "title",
        t("classRoom:tool_resource_with_label", {
          label: getLTIName(serviceName) || serviceName,
        })
      );

      if (version === "1.3") {
        attachmentContextId = _.split(props.attachmentContextId, "_")[1];
      } else {
        attachmentContextId = _.split(resourceLinkId, "_")[1];
      }

      const attachments = [
        {
          metadata: {
            type: "LTI_TOOL",
            service: serviceName,
            allowStudentReportView,
            attachmentContextId,
            disableTeacherReportView,
            useInAppBrowser,
            ...(version === "1.3" && {
              custom: _.get(attachmentDetails, "customData", null),
              lineitem: _.get(attachmentDetails, "lineItem", null),
              endDateTime: _.get(attachmentDetails, "endDateTime", ""),
              startDateTime: _.get(attachmentDetails, "startDateTime", ""),
            }),
          },
          description: _.get(attachmentDetails, "description", null),
          mimeType: null,
          name: name,
          type: "LINK",
          url: _.get(attachmentDetails, "url", null),
          thumbUrl,
        },
      ];

      onLinkAdd({
        attachments,
        id: generateRandomId(),
      });

      toggleLTIComponent();
      if (createLTIScoreTool) {
        createAssessmentTool({
          type: "SCORE",
          parentId: assessmentId,
          parentType,
          portalType,
          assessmentId,
        });
      }
    },
    [
      t,
      onLinkAdd,
      toggleLTIComponent,
      createLTIScoreTool,
      createAssessmentTool,
      assessmentId,
      parentType,
      portalType,
      courseId,
    ]
  );

  return (
    <LTIComponent
      {...props}
      resourceLinkId={assessmentId}
      onLTIModalSave={onLTIModalSave}
      onContentItemSelection={onContentItemSelection}
    />
  );
};

const mapActionCreators = {
  createAssessmentTool,
};
export default connect(null, mapActionCreators)(LTIClassroomWrapper);
